import React, { Component } from "react";
import _ from "lodash";
import axios from "axios";
import "./PlayersBoard.css";

class PlayersBoard extends Component {
  state = {
    keys: ['goals', 'assists', 'saves'],
    top_players: []
  };

  componentDidMount = () => {
    axios.get(`/team-roster-standing/${this.props.teamId}/${this.props.seasonId}`)
      .then((res) => {
        const team = res.data.rosters.teamroster.team;
        const players = team.players.player;
        const goalies = team.goalies.goalie;
        this.sortData([players, players, goalies], this.state.keys);
        this.setState({
          top_players: this.state.top_players
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  sortData = (players, key) => {
    players.map((item, i) => {
      const sorted = _.sortBy(item, p => - p[key[i]]);
      const sliced =  sorted.slice(0, 3);
      return this.state.top_players.push(sliced);
    })
  }

  render() {
    return (
      <div className="top-players">
        { this.state.top_players.length ?
            this.state.top_players.map((item, i) => (
              <div className="top-leaders" key={i}>
              <h3 className='top-leaders-title site-border-color'>
                {`${new Date().getFullYear()} ${i > 1 ? 'Goalie Leaders' : `${this.state.keys[i].slice(0, -1)} Leaders`}`}
              </h3>
                {item.map((item, ii) => (
                  <div className="players-section" key={ii}>
                    <span className="player-info">
                      <img
                        src={item.photo? item.photo : require('~/assets/images/default_mll.jpg')}
                        alt={`${item.firstname} ${item.lastname}`}
                      />
                      {`${ii + 1}. ${item.firstname} ${item.lastname}`}
                    </span>
                    <span className="score">{item[this.state.keys[i]]}</span>
                  </div>
                ))}
              </div>
            ))
          : <div /> }
          <a className='stats-link' href='/stats'>All stats</a>
      </div>
    );
  }
}

export default PlayersBoard;
